import { FieldBase } from '@/domain/mitarbeiter/features/anlageassistent/components/form/fieldComponents/FieldBase';
import { InfoButton } from '@/domain/mitarbeiter/features/anlageassistent/components/InfoButton';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { Body, Heading, RadioGroup, RadioGroupItem } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function RichtwertToggle() {
  const form = useAnlageassistentFormContext();
  const { t } = useTranslation();
  const { ctx } = useAnlageassistentContext();
  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-1 items-center">
        <Heading>
          {t(
            'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.richtwert.description',
          )}
        </Heading>
        <InfoButton>
          <Body>
            {t(
              'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.richtwert.info',
            )}
          </Body>
        </InfoButton>
      </div>
      <div>
        <form.AppField
          name="bezahlung.arbeitszeitkonto.stundenloehner.richtwert"
          listeners={{
            onChange: () => {
              ctx.resetDependentFields(
                'bezahlung.arbeitszeitkonto.stundenloehner.richtwert',
              );
            },
          }}>
          {(field) => (
            <FieldBase>
              <RadioGroup
                value={field.state.value?.toString()}
                onValueChange={(e) => {
                  field.handleChange(e === 'true');
                }}
                className="flex flex-row">
                <RadioGroupItem
                  variant="card"
                  layout="horizontal"
                  label={t(
                    'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.richtwert.options.true',
                  )}
                  value={'true'}
                  className="w-full"
                />
                <RadioGroupItem
                  variant="card"
                  layout="horizontal"
                  label={t(
                    'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.richtwert.options.false',
                  )}
                  value={'false'}
                  className="w-full"
                />
              </RadioGroup>
            </FieldBase>
          )}
        </form.AppField>
      </div>
    </div>
  );
}
